import fetch from 'auth/FetchInterceptor'

const DealService = {
  getAll: (params = null) =>
    fetch({ url: '/crm/deals', method: 'get', params }),
  get: (id) => fetch({ url: `/crm/deals/${id}`, method: 'get' }),
  create: (data) => fetch({ url: '/crm/deals', method: 'post', data }),
  update: (id, data) =>
    fetch({ url: `/crm/deals/${id}`, method: 'patch', data }),
  remove: (id) => fetch({ url: `/crm/deals/${id}`, method: 'delete' }),
  move: (id, payload = {}) =>
    fetch({ url: `/crm/deals/${id}/move`, method: 'post', data: payload }),
}

export default DealService
